import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAddHolidaySchema, IHolidayState, IHoliday } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IHolidayState = {
  addHoliday: {},
  holidays: {},
  deleteHoliday: {},
  updateHoliday: {},
};
const slice = createSlice({
  name: 'holidays',
  initialState,
  reducers: {
    addHoliday(state, action: PayloadAction<IAddHolidaySchema>) {
      state.addHoliday.status = RequestStatus.RUNNING;
    },
    addHolidaySuccess(state, action: PayloadAction<IAddHolidaySchema>) {
      state.addHoliday.status = RequestStatus.SUCCESS;
      state.addHoliday.data = action.payload;
    },
    addHolidayFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addHoliday.status = RequestStatus.ERROR;
      state.addHoliday.error = action.payload;
    },
    //
    getHolidays(state) {
      state.holidays.status = RequestStatus.RUNNING;
    },
    getHolidaysSuccess(state, action: PayloadAction<IHolidayState['holidays']['data']>) {
      state.holidays.status = RequestStatus.SUCCESS;
      state.holidays.data = action.payload;
    },
    getHolidaysFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addHoliday.status = RequestStatus.ERROR;
      state.addHoliday.error = action.payload;
    },
    //
    deleteHoliday(state, action: PayloadAction<{ id: number }>) {
      state.deleteHoliday.status = RequestStatus.RUNNING;
    },
    deleteHolidaySuccess(state) {
      state.deleteHoliday.status = RequestStatus.SUCCESS;
    },
    deleteHolidayFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteHoliday.status = RequestStatus.ERROR;
      state.deleteHoliday.error = action.payload;
    },
    //
    updateHoliday(state, action: PayloadAction<IHoliday>) {
      state.updateHoliday.status = RequestStatus.RUNNING;
    },
    updateHolidaySuccess(state, action: PayloadAction<IHoliday>) {
      state.updateHoliday.status = RequestStatus.SUCCESS;
      state.updateHoliday.data = action.payload;
    },
    updateHolidayFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateHoliday.status = RequestStatus.ERROR;
      state.updateHoliday.error = action.payload;
    },
  },
});
export default slice.reducer;
export const {
  addHoliday,
  addHolidayFailed,
  addHolidaySuccess,
  getHolidays,
  getHolidaysSuccess,
  getHolidaysFailed,
  deleteHoliday,
  deleteHolidaySuccess,
  deleteHolidayFailed,
  updateHoliday,
  updateHolidaySuccess,
  updateHolidayFailed,
} = slice.actions;
